import { type ReactNode, createContext, useContext } from 'react';

import type { InvoiceDraft, ServicoInput, TomadorInput, ValorInput } from '~/schemas/invoice';

export type WizardStep = 1 | 2 | 3 | 4;

export interface WizardContextValue {
  step: WizardStep;
  setStep(next: WizardStep): void;
  draft: InvoiceDraft;
  setTomador(next: TomadorInput | ((prev: TomadorInput) => TomadorInput)): void;
  setServico(next: ServicoInput | ((prev: ServicoInput) => ServicoInput)): void;
  setValor(next: ValorInput | ((prev: ValorInput) => ValorInput)): void;
  resetDraft(): void;
}

const WizardContext = createContext<WizardContextValue | null>(null);

interface WizardProviderProps extends WizardContextValue {
  children: ReactNode;
}

export function WizardProvider({ children, ...value }: WizardProviderProps): JSX.Element {
  return <WizardContext.Provider value={value}>{children}</WizardContext.Provider>;
}

export function useWizard(): WizardContextValue {
  const context = useContext(WizardContext);
  if (!context) {
    throw new Error('useWizard só pode ser usado dentro de WizardProvider');
  }
  return context;
}
